import React from 'react';
import { NavLink } from 'react-router-dom';
const NewAccountBanner = () => {
  return (
    <>
      <section className='page-banner-section'>
        <div className='container'>
          <div className='banner-section'>
            <div className='breadcrumb-section'>
              <div className='link'>
                <NavLink to="/" className="breadcrumb-link">Home</NavLink>
              </div>
              <div className='seperator'>/</div>
              <div className='link'>
                <div className="breadcrumb-link">Account</div>
              </div>
            </div>
            <div className='page-title'>
              <h1 className='title'>Modify Account</h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewAccountBanner;